import front from '../components/icon/front.vue'
import shop from '../components/icon/shop.vue'
import commodity2 from '../components/icon/commodity2.vue'
import install from '../components/icon/install.vue'
import usermamage from '../components/icon/usermamage.vue'
import { canViewIndex, canViewEq, canViewUser } from '../utils/permission'
import store from '../store'
const menus = [
  {
    icon: front,
    title: '首页',
    path: '/',
    hidden: () => !canViewIndex()
  },
  {
    icon: shop,
    title: '粮库管理',
    path: '/graindepot'
  },
  {
    icon: usermamage,
    title: '用户管理',
    path: '/users',
    hidden: () => !canViewUser()
  },
  {
    icon: commodity2,
    title: '设备管理',
    path: '/equipment',
    hidden: () => !canViewEq()
  },
  {
    icon: install,
    title: '设置',
    hidden: () => !store.getters.isAdmin,
    path: '/settings/basics'
  }
]
export default menus
